import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "plan-page" }
const _hoisted_2 = { class: "plan-inner" }
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "hero-actions" }
const _hoisted_5 = { class: "quick-head" }
const _hoisted_6 = {
  key: 0,
  class: "zile-hint"
}
const _hoisted_7 = { class: "scheduler-card" }
const _hoisted_8 = { class: "appt-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_DxScheduler = _resolveComponent("DxScheduler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hero-txt" }, [
          _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
          _createElementVNode("h1", { class: "hero-title" }, "Planificare concediu"),
          _createElementVNode("p", { class: "hero-sub" }, "Planifică-ți perioadele de concediu pentru anul selectat.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            class: "btn-nou",
            "prepend-icon": "mdi-plus",
            onClick: _ctx.deschideAdaugare
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Adaugă perioadă ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_select, {
            modelValue: _ctx.an,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.an) = $event)),
              _ctx.onAnChanged
            ],
            items: _ctx.ani,
            label: "An",
            variant: "solo",
            density: "compact",
            "hide-details": "",
            style: {"max-width":"120px"},
            class: "an-select"
          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
        ])
      ]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog) = $event)),
        "max-width": "440"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "quick-card" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_icon, {
                  color: "#ff5722",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-calendar-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Perioadă de concediu", -1))
              ]),
              _createVNode(_component_v_card_text, { class: "pt-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.form.DataInceput,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.DataInceput) = $event)),
                    type: "date",
                    label: "De la",
                    variant: "outlined",
                    density: "comfortable",
                    "hide-details": "",
                    class: "mb-3"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.form.DataSfarsit,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.DataSfarsit) = $event)),
                    type: "date",
                    label: "Până la",
                    variant: "outlined",
                    density: "comfortable",
                    "hide-details": "",
                    class: "mb-3"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_textarea, {
                    modelValue: _ctx.form.Observatie,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Observatie) = $event)),
                    label: "Observație (opțional)",
                    variant: "outlined",
                    density: "comfortable",
                    rows: "2",
                    "hide-details": "",
                    "auto-grow": ""
                  }, null, 8, ["modelValue"]),
                  (_ctx.form.DataInceput && _ctx.form.DataSfarsit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.nrZile) + " " + _toDisplayString(_ctx.nrZile === 1 ? 'zi' : 'zile') + " planificate", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "px-4 pb-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog = false))
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Anulează", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    class: "btn-nou",
                    disabled: !_ctx.formValid || _ctx.salving,
                    loading: _ctx.salving,
                    onClick: _ctx.salveazaRapid
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("Salvează", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "#ff5722",
            class: "mb-2"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_DxScheduler, {
          ref: "schedulerRef",
          "data-source": _ctx.appointments,
          "current-date": _ctx.currentDate,
          "current-view": "month",
          views: ['month'],
          "text-expr": "Text",
          "start-date-expr": "StartDate",
          "end-date-expr": "EndDate",
          "all-day-expr": "AllDay",
          "description-expr": "Description",
          "recurrence-rule-expr": "RecurrenceRule",
          "key-expr": "ID",
          height: "700",
          "appointment-template": "apptTmpl",
          editing: { allowAdding: true, allowUpdating: true, allowDeleting: true, allowResizing: true, allowDragging: true },
          onAppointmentAdded: _ctx.onAppointmentAdded,
          onAppointmentUpdated: _ctx.onAppointmentUpdated,
          onAppointmentDeleted: _ctx.onAppointmentDeleted
        }, {
          apptTmpl: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_8, _toDisplayString(data.appointmentData.Text), 1)
          ]),
          _: 1
        }, 8, ["data-source", "current-date", "onAppointmentAdded", "onAppointmentUpdated", "onAppointmentDeleted"])
      ])
    ])
  ]))
}